export const iconFontAwesomeFilesFileImport = (
	<i className="fa-solid fa-file-import"></i>
);
